namespace Matrix.Workflow {
    export interface TaskInstanceRow {
        TaskInstanceId?: number;
        WorkflowInstanceId?: number;
        TaskId?: number;
        CorrelationId?: string;
        StatusCode?: string;
        PriorityCode?: string;
        Actions?: string;
        CurrentAction?: string;
        StartedWhen?: string;
        FinishedWhen?: string;
        DurationMs?: number;
        StdOut?: string;
        StdErr?: string;
        Properties?: string;
        C1Name?: string;
        C1?: string;
        C2Name?: string;
        C2?: string;
        C3Name?: string;
        C3?: string;
        C4Name?: string;
        C4?: string;
        C5Name?: string;
        C5?: string;
        C6Name?: string;
        C6?: string;
        C7Name?: string;
        C7?: string;
        C8Name?: string;
        C8?: string;
        C9Name?: string;
        C9?: string;
        C10Name?: string;
        C10?: string;
        B1Name?: string;
        B1?: boolean;
        B2Name?: string;
        B2?: boolean;
        B3Name?: string;
        B3?: boolean;
        B4Name?: string;
        B4?: boolean;
        B5Name?: string;
        B5?: boolean;
        B6Name?: string;
        B6?: boolean;
        B7Name?: string;
        B7?: boolean;
        B8Name?: string;
        B8?: boolean;
        B9Name?: string;
        B9?: boolean;
        B10Name?: string;
        B10?: boolean;
        N1Name?: string;
        N1?: number;
        N2Name?: string;
        N2?: number;
        N3Name?: string;
        N3?: number;
        N4Name?: string;
        N4?: number;
        N5Name?: string;
        N5?: number;
        N6Name?: string;
        N6?: number;
        N7Name?: string;
        N7?: number;
        N8Name?: string;
        N8?: number;
        N9Name?: string;
        N9?: number;
        N10Name?: string;
        N10?: number;
        F1Name?: string;
        F1?: number;
        F2Name?: string;
        F2?: number;
        F3Name?: string;
        F3?: number;
        F4Name?: string;
        F4?: number;
        F5Name?: string;
        F5?: number;
        F6Name?: string;
        F6?: number;
        F7Name?: string;
        F7?: number;
        F8Name?: string;
        F8?: number;
        F9Name?: string;
        F9?: number;
        F10Name?: string;
        F10?: number;
        D1Name?: string;
        D1?: string;
        D2Name?: string;
        D2?: string;
        D3Name?: string;
        D3?: string;
        D4Name?: string;
        D4?: string;
        D5Name?: string;
        D5?: string;
        Txt1Name?: string;
        Txt1?: string;
        Txt2Name?: string;
        Txt2?: string;
        Txt3Name?: string;
        Txt3?: string;
        Txt4Name?: string;
        Txt4?: string;
        Txt5Name?: string;
        Txt5?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        WorkflowInstanceCreatedDate?: string;
        WorkflowCode?: string;
        WorkflowInstanceStatusCode?: string;
        WorkflowInstanceProperties?: string;
        WorkflowInstanceKey1?: string;
        WorkflowInstanceKey2?: string;
        WorkflowInstanceKey3?: string;
        WorkflowInstanceKey4?: string;
        WorkflowInstanceKey5?: string;
        WorkflowInstanceRowId?: number;
        TaskWorkflowCode?: string;
        TaskCode?: string;
        TaskSequenceNumber?: number;
        TaskDescription?: string;
        TaskReadPermissions?: string;
        TaskWritePermissions?: string;
        TaskProperties?: string;
        TaskClass1?: string;
        TaskClass2?: string;
        TaskClass3?: string;
        TaskClass4?: string;
        TaskClass5?: string;
        TaskKey1?: string;
        TaskKey2?: string;
        TaskKey3?: string;
        TaskKey4?: string;
        TaskKey5?: string;
        TaskRowId?: number;
        StatusDescription?: string;
        StatusRowId?: number;
    }

    export namespace TaskInstanceRow {
        export const idProperty = 'TaskInstanceId';
        export const nameProperty = 'StatusCode';
        export const localTextPrefix = 'Workflow.TaskInstance';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:TaskInstance';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            TaskInstanceId = "TaskInstanceId",
            WorkflowInstanceId = "WorkflowInstanceId",
            TaskId = "TaskId",
            CorrelationId = "CorrelationId",
            StatusCode = "StatusCode",
            PriorityCode = "PriorityCode",
            Actions = "Actions",
            CurrentAction = "CurrentAction",
            StartedWhen = "StartedWhen",
            FinishedWhen = "FinishedWhen",
            DurationMs = "DurationMs",
            StdOut = "StdOut",
            StdErr = "StdErr",
            Properties = "Properties",
            C1Name = "C1Name",
            C1 = "C1",
            C2Name = "C2Name",
            C2 = "C2",
            C3Name = "C3Name",
            C3 = "C3",
            C4Name = "C4Name",
            C4 = "C4",
            C5Name = "C5Name",
            C5 = "C5",
            C6Name = "C6Name",
            C6 = "C6",
            C7Name = "C7Name",
            C7 = "C7",
            C8Name = "C8Name",
            C8 = "C8",
            C9Name = "C9Name",
            C9 = "C9",
            C10Name = "C10Name",
            C10 = "C10",
            B1Name = "B1Name",
            B1 = "B1",
            B2Name = "B2Name",
            B2 = "B2",
            B3Name = "B3Name",
            B3 = "B3",
            B4Name = "B4Name",
            B4 = "B4",
            B5Name = "B5Name",
            B5 = "B5",
            B6Name = "B6Name",
            B6 = "B6",
            B7Name = "B7Name",
            B7 = "B7",
            B8Name = "B8Name",
            B8 = "B8",
            B9Name = "B9Name",
            B9 = "B9",
            B10Name = "B10Name",
            B10 = "B10",
            N1Name = "N1Name",
            N1 = "N1",
            N2Name = "N2Name",
            N2 = "N2",
            N3Name = "N3Name",
            N3 = "N3",
            N4Name = "N4Name",
            N4 = "N4",
            N5Name = "N5Name",
            N5 = "N5",
            N6Name = "N6Name",
            N6 = "N6",
            N7Name = "N7Name",
            N7 = "N7",
            N8Name = "N8Name",
            N8 = "N8",
            N9Name = "N9Name",
            N9 = "N9",
            N10Name = "N10Name",
            N10 = "N10",
            F1Name = "F1Name",
            F1 = "F1",
            F2Name = "F2Name",
            F2 = "F2",
            F3Name = "F3Name",
            F3 = "F3",
            F4Name = "F4Name",
            F4 = "F4",
            F5Name = "F5Name",
            F5 = "F5",
            F6Name = "F6Name",
            F6 = "F6",
            F7Name = "F7Name",
            F7 = "F7",
            F8Name = "F8Name",
            F8 = "F8",
            F9Name = "F9Name",
            F9 = "F9",
            F10Name = "F10Name",
            F10 = "F10",
            D1Name = "D1Name",
            D1 = "D1",
            D2Name = "D2Name",
            D2 = "D2",
            D3Name = "D3Name",
            D3 = "D3",
            D4Name = "D4Name",
            D4 = "D4",
            D5Name = "D5Name",
            D5 = "D5",
            Txt1Name = "Txt1Name",
            Txt1 = "Txt1",
            Txt2Name = "Txt2Name",
            Txt2 = "Txt2",
            Txt3Name = "Txt3Name",
            Txt3 = "Txt3",
            Txt4Name = "Txt4Name",
            Txt4 = "Txt4",
            Txt5Name = "Txt5Name",
            Txt5 = "Txt5",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            WorkflowInstanceCreatedDate = "WorkflowInstanceCreatedDate",
            WorkflowCode = "WorkflowCode",
            WorkflowInstanceStatusCode = "WorkflowInstanceStatusCode",
            WorkflowInstanceProperties = "WorkflowInstanceProperties",
            WorkflowInstanceKey1 = "WorkflowInstanceKey1",
            WorkflowInstanceKey2 = "WorkflowInstanceKey2",
            WorkflowInstanceKey3 = "WorkflowInstanceKey3",
            WorkflowInstanceKey4 = "WorkflowInstanceKey4",
            WorkflowInstanceKey5 = "WorkflowInstanceKey5",
            WorkflowInstanceRowId = "WorkflowInstanceRowId",
            TaskWorkflowCode = "TaskWorkflowCode",
            TaskCode = "TaskCode",
            TaskSequenceNumber = "TaskSequenceNumber",
            TaskDescription = "TaskDescription",
            TaskReadPermissions = "TaskReadPermissions",
            TaskWritePermissions = "TaskWritePermissions",
            TaskProperties = "TaskProperties",
            TaskClass1 = "TaskClass1",
            TaskClass2 = "TaskClass2",
            TaskClass3 = "TaskClass3",
            TaskClass4 = "TaskClass4",
            TaskClass5 = "TaskClass5",
            TaskKey1 = "TaskKey1",
            TaskKey2 = "TaskKey2",
            TaskKey3 = "TaskKey3",
            TaskKey4 = "TaskKey4",
            TaskKey5 = "TaskKey5",
            TaskRowId = "TaskRowId",
            StatusDescription = "StatusDescription",
            StatusRowId = "StatusRowId"
        }
    }
}
